module.exports = __webpack_public_path__ + "img/2024-03-19b_2.5c5417c9.jpg";